import { render, staticRenderFns } from "./StartForm4.vue?vue&type=template&id=6785b99c&scoped=true"
import script from "./StartForm4.vue?vue&type=script&lang=ts"
export * from "./StartForm4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6785b99c",
  null
  
)

export default component.exports